import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { DataGrid } from "@mui/x-data-grid";
import clsx from "clsx";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import { dateGridLocalTextOptions } from "../../../shared/services/dataGridLocalTextOptions";
import { codeCroups } from "./codeCroups";

class WinterMaintenceUnitsPeriodTable extends Component {
  getColumns() {
    const sensorCellStyle = (params) => {
      return clsx("sensorCell", {
        positive: params.value,
      });
    };

    const renderDistanceDumpCell = (params) => {
      if (!params.row.isDumpSensor) return <div></div>;

      return params.value;
    };

    const renderDistanceSandCell = (params) => {
      if (!params.row.isSandSensor) return <div></div>;

      return params.value;
    };

    const renderGroupCell = (params) => {
      return (
        <div style={{ display: "flex" }}>
          {params.value.map((group, index) => {
            return (
              <div key={index}>
                <TooltipWrapper title={group.title} position="top">
                  <div style={{ marginRight: "3px" }}>{codeCroups[group.id]};</div>
                </TooltipWrapper>
              </div>
            );
          })}
        </div>
      );
    };

    const renderTitleCell = (params) => {
      return (
        <a href={`/cars/${params.row.id}/intimerange`} target="_blank" rel="noreferrer">
          {params.row.registerNumber}
        </a>
      );
    };

    return [
      {
        field: "number",
        headerName: "",
        width: 15,
      },
      {
        field: "registerNumber",
        headerName: "Рег. номер ",
        renderCell: renderTitleCell,
        width: 120,
      },
      {
        field: "title",
        headerName: "Подпись",
        width: 150,
      },

      {
        field: "isDumpSensor",
        headerName: "Датчик отвала",
        type: "boolean",
        cellClassName: sensorCellStyle,
        width: 100,
      },
      {
        field: "isSandSensor",
        headerName: "Датчик ПСС",
        type: "boolean",
        cellClassName: sensorCellStyle,
        width: 100,
      },
      {
        field: "distance",
        headerName: "Пробег км.",
        width: 100,
      },
      {
        field: "distanceDump1",
        headerName: "Работа отвала",
        renderCell: renderDistanceDumpCell,
        width: 100,
      },
      {
        field: "distanceSand",
        headerName: "Работа ПСС",
        renderCell: renderDistanceSandCell,
        width: 100,
      },

      {
        field: "groups",
        headerName: "Группы",
        renderCell: renderGroupCell,
        width: 300,
      },
    ];
  }

  getRows() {
    const { units } = this.props;

    return units.map((unit, i) => {
      return {
        number: i + 1,
        ...unit,
        ...unit.dataRoute,
      };
    });
  }

  render() {
    const tableSyle = {
      "& .sensorCell.negative": {},
      "& .sensorCell.positive": {
        backgroundColor: "rgba(157, 255, 118, 0.49)",
      },
    };

    return (
      <div>
        <DataGrid
          className={styles.MuiButtonBase_resolve}
          sx={tableSyle}
          rowHeight={30}
          ref={"DataGrid"}
          localeText={{
            ...dateGridLocalTextOptions,
            footerRowSelected: (count) => `Транспортных средств выбранно: ${count}`,
            MuiTablePagination: {
              disabled: true,
              rowsPerPage: 100,
              rowsPerPageOptions: 100,
              backIconButtonProps: null,
              labelDisplayedRows: ({ from, to, count }) => `Показанно транспортных средств: ${count}`,
            },
          }}
          initialState={{
            columns: {
              columnVisibilityModel: {
                dumpSensorLongInaction: false,
                sandSensorLongInaction: false,
              },
            },
          }}
          checkboxSelection={false}
          rows={this.getRows()}
          columns={this.getColumns()}
          disableRowSelectionOnClick
        />
      </div>
    );
  }
}

export default React.memo(WinterMaintenceUnitsPeriodTable);
